import { useTranslation } from "../../i18n";

/**
 * Notification log viewer for a campaign.
 */
export default function CampaignLog({ log }) {
  const { t } = useTranslation();

  if (!log || log.items.length === 0) {
    return (
      <div className="text-c-gray-400 text-sm py-4 text-center">
        {t("campaign.noNotifications")}
      </div>
    );
  }

  return (
    <div className="overflow-auto max-h-[300px]">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-c-gray-400/30">
            <th className="text-left py-2 px-2 text-c-gray-400">
              {t("campaign.colCustomer")}
            </th>
            <th className="text-left py-2 px-2 text-c-gray-400">
              {t("campaign.colPhone")}
            </th>
            <th className="text-left py-2 px-2 text-c-gray-400">
              {t("campaign.colSentAt")}
            </th>
            <th className="text-left py-2 px-2 text-c-gray-400">
              {t("campaign.colVariant")}
            </th>
          </tr>
        </thead>
        <tbody>
          {log.items.map((entry) => (
            <tr key={entry.id} className="border-b border-c-gray-400/10">
              <td className="py-2 px-2">
                {entry.firstname || `#${entry.customerId}`}
              </td>
              <td className="py-2 px-2 text-c-gray-400">
                {entry.phone || "—"}
              </td>
              <td className="py-2 px-2 text-c-gray-400">
                {new Date(entry.sentAt).toLocaleString()}
              </td>
              <td className="py-2 px-2">{entry.variant || "—"}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="text-c-gray-400 text-xs pt-2 text-right">{log.total}</div>
    </div>
  );
}
